import { ShieldCheck } from "lucide-react";
import { Reveal } from "./Reveal";
import { MEMBERSHIPS } from "../data/content";

export const Memberships = () => (
  <section className="py-16 border-y border-[#E3DCCB] bg-[#F1EDE3]" data-testid="memberships-section">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal>
        <p className="font-mono-tag text-xs uppercase tracking-[0.3em] text-teal-700 text-center mb-10">
          Member — Prestigious Societies
        </p>
      </Reveal>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
        {MEMBERSHIPS.map((m, i) => (
          <Reveal key={m.abbr} delay={i * 0.07}>
            <div className="text-center group" data-testid={`membership-${m.abbr.toLowerCase().replace(/\s/g, "-")}`}>
              <ShieldCheck size={18} className="mx-auto text-amber-600 mb-3 group-hover:text-amber-700 transition-colors" />
              <p className="font-serif-display text-xl font-semibold text-stone-800">{m.abbr}</p>
              <p className="mt-1 text-xs text-slate-500 leading-snug max-w-[200px] mx-auto">{m.full}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
